import React, { Component } from "react";
import { Link } from "react-router-dom";
import { routes } from "../routes";
import Header from "./Header";
import Footer from "./Footer";
import ScrollBar from "react-scrollbar";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Collapse } from "react-collapse";
import "react-perfect-scrollbar/dist/css/styles.css";

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      routes: [],
    };
  }
  componentDidMount() {
    let r = routes;
    let found = [];
    let child = [];
    let mod = JSON.parse(localStorage.getItem("menu"));
    if (mod !== null) {
      let x = mod.sort(function (a, b) {
        return a.sort - b.sort;
      });

      x.map((data, key) => {
        if (data.parent_id === null) {
          if (r.find((element) => element.name === data.name) !== undefined) {
            found[key] = r.find((element) => element.name === data.name);
          }
        }
      });
    }
    this.setState({ routes: found });
  }
  getMenu = (route) => {
    return route.map((prop, key) => {
      if (prop.layout === "/admin" && prop.place === "navbar") {
        if (!prop.child) {
          return (
            <li className="nav-item" key={key}>
              <Link
                to={prop.path}
                className={`nav-link ${
                  this.props.match.url === prop.path ? "active" : ""
                  }`}
                role="button"
              >
                <i className={prop.icon} />
                &nbsp;
                <span
                  className={"nav-link-text"}
                  style={{ whiteSpace: "nowrap" }}
                >
                  {prop.name}
                </span>
              </Link>
            </li>
          );
        } else {
          let mod = JSON.parse(localStorage.getItem("menu"));
          return (
            <li className="nav-item" key={key}>
              <a
                href={`#sub-${prop.name.split(" ").join("-")}`}
                className={`nav-link ${
                  this.props.match.url.split("_")[0] === prop.path
                    ? "active"
                    : ""
                  }`}
                key={key}
                role="button"
                data-toggle="collapse"
                aria-controls={`#sub-${prop.name.split(" ").join("-")}`}
                aria-expanded="false"
              >
                <i className={prop.icon} /> &nbsp;
                <span
                  className={"nav-link-text"}
                  style={{ whiteSpace: "nowrap" }}
                >
                  {prop.name}
                </span>
              </a>
              {/* <Collapse isOpened={ true } > */}
              <div
                id={`sub-${prop.name.split(" ").join("-")}`}
                className="collapse"
              >
                <ul className="nav nav-sm flex-column">
                  {prop.child.map((child, key2) => {
                    let x = mod.find((element) => element.name === child.name)
                      ? true
                      : false;
                    if (x) {
                      return (
                        <li className="nav-item" key={key2}>
                          <Link
                            className={`nav-link ${
                              this.props.match.url === child.path
                                ? "active"
                                : ""
                              }`}
                            to={child.path}
                          >
                            {child.name}
                          </Link>
                        </li>
                      );
                    }
                  })}
                </ul>
              </div>
              {/* </Collapse> */}
            </li>
          );
        }
      } else {
        return null;
      }
    });
  };

  collapseHandler = () => {
    this.setState({
      isCollapsed: !this.state.isCollapsed,
    });
  };

  render() {
    return (
      <div>
        {/* Sidenav */}
        <nav
          className="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white"
          id="sidenav-main"
        >
          <div className="scrollbar-inner">
            <PerfectScrollbar>
              {/* Brand */}
              <div className="sidenav-header d-flex align-items-center">
                <Link
                  className="navbar-brand"
                  to="/home"
                  style={{ padding: "0px" }}
                >
                  <img
                    src="./assets/img/brand/smartsehat.png"
                    className="navbar-brand-img"
                    alt="..."
                  />
                </Link>
                <div className="ml-auto">
                  {/* Sidenav toggler */}
                  <div
                    className="sidenav-toggler d-none d-xl-block"
                    data-action="sidenav-unpin"
                    data-target="#sidenav-main"
                  >
                    <div className="sidenav-toggler-inner">
                      <i className="sidenav-toggler-line" />
                      <i className="sidenav-toggler-line" />
                      <i className="sidenav-toggler-line" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="navbar-inner">
                {/* Collapse */}
                <div
                  className="collapse navbar-collapse"
                  id="sidenav-collapse-main"
                >
                  {/* Nav items */}
                  <ul className="navbar-nav">
                    {this.getMenu(this.state.routes)}
                  </ul>
                </div>
              </div>
              {/* </div> */}
            </PerfectScrollbar>
          </div>
        </nav>
        {/* Main content */}
        <div className="main-content" id="panel">
          <Header />
          {this.props.children}
          {/* <Switch>
            {routes.map((prop, key) => {
              return <Route path={prop.path} component={prop.component} key={key} />;
            })}
          </Switch> */}
          <Footer />
        </div>
      </div>
    );
  }
}
